import { useEffect }            from 'react';
import { store }                from 'index';
import { groupUrl }             from 'utils/constants'
import { GET_USER_VIDEOS_SAGA } from 'actions/contentActions';

const useGetUserVideos = (guest: boolean) => {

    const state = store.getState();
    const { userInfo } = state.data;

    useEffect(() => {

        if ( groupUrl || guest || !userInfo.userEmail.length ) {
          return
        }
         store.dispatch(GET_USER_VIDEOS_SAGA({ userEmail: userInfo.userEmail }));
    
      },[ userInfo, guest ])


}
export default useGetUserVideos;

